import React from 'react';
import { IAssessmentManagementTableProps } from './assessment-management.models';
import { Anchor, formatDate, KebabMenu, MenuItem, Pager, Table, TableColumn, TableRow } from '@keplerco/core';
import { PagerConnector } from '../../components/general/pager-connector/pager-connector';
import { AssessmentSubType } from '../../enums/assessment-type';
import { AssessmentStatusChip } from '../../components/chips/assessment-status.chip';
import { AssessmentStatus } from '../../enums/assessment-status';
import { AssessmentListItemResponse } from '../../overmind/actions';
import { getAssessmentSubTypeDescription } from '../../library/helpers/get-assessment-sub-type-description';

export function AssessmentManagementTable(props: IAssessmentManagementTableProps): JSX.Element {
  function generateKebabMenuItems(skillAssessment: AssessmentListItemResponse): MenuItem[] {
    const isActive = skillAssessment.assessmentStatus === AssessmentStatus.Active;
    const isArchived = skillAssessment.assessmentStatus === AssessmentStatus.Archived;
    const isClosed = skillAssessment.assessmentStatus === AssessmentStatus.Closed;
    const isDraft = skillAssessment.assessmentStatus === AssessmentStatus.Draft;

    const kebabMenuItems: MenuItem[] = [
      {
        label: 'Archive',
        onClick: () => props.onClickArchiveDraftAssessmentHandler(skillAssessment),
        disabled: isArchived || isActive,
      },
      {
        label: 'Edit',
        onClick: () => props.onClickManageAssessmentDraftHandler(skillAssessment),
        disabled: !isDraft,
      },
      {
        label: 'Close',
        onClick: () => props.onClickCompleteHandler(skillAssessment),
        disabled: !isActive || isClosed,
      },
      {
        label: `View ${skillAssessment.assessmentSubType === AssessmentSubType.RatingAssessment ? '' : 'assignees'}`,
        onClick: () => skillAssessment.assessmentSubType === AssessmentSubType.RatingAssessment ? props.onClickViewAssessmentOverview(skillAssessment) : props.onClickViewAssigneesHandler(skillAssessment),
        disabled: skillAssessment.assessmentSubType !== AssessmentSubType.RatingAssessment && isDraft,
      },
    ];

    return kebabMenuItems;
  }

  return (
    <Table
      onConfigClicked={props.onConfigClicked}
      footerContent={
        <PagerConnector onPageChange={props.onPageChangeHandler} defaultPageNumber={props.searchParams?.page ?? 1} pageCount={props.totalPages}>
          {connector => {
            return <Pager {...connector} />;
          }}
        </PagerConnector>
      }
    >
      {props.skillAssessments.map((skillAssessment, index) => {
        const isLoading = props.loadingSkillAssessments.includes(String(skillAssessment.assessmentId!));

        return (
          <TableRow
            configCell={() => {
              return <span style={{ visibility: isLoading ? 'hidden' : undefined, pointerEvents: isLoading ? 'none' : undefined }}>{generateKebabMenuItems(skillAssessment).length > 0 && <KebabMenu items={generateKebabMenuItems(skillAssessment)} />}</span>;
            }}
            id={index}
            key={index}
            isLoading={isLoading}
          >
            <TableColumn id="name" label="Name" locked>
              <Anchor
                hovertype="opacity"
                textTransform="none"
                onClick={() => {
                  skillAssessment.assessmentStatus === AssessmentStatus.Draft ? props.onClickManageAssessmentDraftHandler(skillAssessment) : props.onClickViewAssessmentOverview(skillAssessment);
                }}
              >
                {skillAssessment.name}
              </Anchor>
            </TableColumn>

            <TableColumn hidden={!props.columnConfiguration.find(i => i.key === 'assessmentType')?.selected} id="assessmentType" label="Assessment type">
              {getAssessmentSubTypeDescription(skillAssessment.assessmentSubType)}
            </TableColumn>

            <TableColumn hidden={!props.columnConfiguration.find(i => i.key === 'dateCreated')?.selected} id="dateCreated" label="Date created">
              {!!skillAssessment.dateCreated && formatDate(new Date(skillAssessment.dateCreated))}
            </TableColumn>

            <TableColumn hidden={!props.columnConfiguration.find(i => i.key === 'Status')?.selected} id="status" label="Status">
              <AssessmentStatusChip assessmentStatus={skillAssessment.assessmentStatus} />
            </TableColumn>
          </TableRow>
        );
      })}
    </Table>
  );
}
